import Vue from 'vue'

import ScrollBar from 'vue2-scrollbar'

import Navbar from '@/components/Layout/Navbar'
import Toolbar from '@/components/Layout/Toolbar'
import Sidebar from '@/components/Layout/Sidebar'
import Page from '@/components/Layout/Page'

import SelectPicker from '@/components/Inputs/Select'
import TimePicker from '@/components/Inputs/Time'
import DatePicker from '@/components/Inputs/Date'
import ColorPicker from '@/components/Inputs/Color'
import CountryPicker from '@/components/Inputs/Country'
import CountryTmz from '@/components/Inputs/CountryTmz'
import MoneyPicker from '@/components/Inputs/Money'

import DataTable from '@/components/DataTable'
import DataTableServerPagination from '@/components/DataTableServerPagination'
import DataTableSelector from '@/components/DataTableSelector'

Vue.component('Scrollbar', ScrollBar)

Vue.component('Navbar', Navbar)
Vue.component('Toolbar', Toolbar)
Vue.component('Sidebar', Sidebar)
Vue.component('Page', Page)

Vue.component('SelectPicker', SelectPicker)
Vue.component('TimePicker', TimePicker)
Vue.component('DatePicker', DatePicker)
Vue.component('ColorPicker', ColorPicker)
Vue.component('CountryPicker', CountryPicker)
Vue.component('CountryTmz', CountryTmz)
Vue.component('MoneyPicker', MoneyPicker)
Vue.component('Datatable', DataTable)
Vue.component('DataTableServerPagination', DataTableServerPagination)
Vue.component('DataTableSelector', DataTableSelector)
